__webpack_require__.p = "https://fe.gamma.registry.geostudio.app.amazon.dev/";